import React from 'react'

export default class Loading extends React.Component {
  render () {
    return (
      <div className="loader">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
    )
  }
}